<template>
  <AwlModalCard class="px-5 py-4" :border="false">
    <h3 class="text-primary text-center mb-3">Si dispone di un bilancio?</h3>
    <button class="btn small btn-outline-secondary" @click="goBack">
      <i class="fas fa-angle-left mr-1"></i>
      Indietro
    </button>

    <img src="@/assets/images/got-a-balance.png" class="d-block w-50 mx-auto mb-3" />
    <p class="small text-muted text-center">
      Se la tue azienda non è una startup deve essere inserito un bilancio a data recente. Ricordati che dovrai poi inserire i dati consuntivi per tutti i mesi dalla data del bilancio fino all'ultimo mese concluso (esempio, se oggi è ottobre e il bilancio inserito è di giugno, dovranno essere inseriti i dati consuntivi di luglio, agosto e settembre.
    </p>
    <p class="small text-muted text-center">
      Ricorda inoltre che dovrai avere a disposizione i tempi di ammortamento dei principali cespiti in bilancio (o i tempi medi per ogni categoria), i piani di ammortamento dei finanziamenti e gli scadenzari attivi e passivi. Nel caso di startup sarà necessario inserire i dati consuntivi dall'avvio dell'attività fino all'ultimo mese concluso.
    </p>

    <div class="d-flex justify-content-between">
      <button type="button" class="btn btn-primary" @click.prevent="$emit('has-balance', false)">Non ho un bilancio</button>
      <button type="button" class="btn btn-primary" @click.prevent="$emit('has-balance', true)">Sì, ho un bilancio</button>
    </div>
  </AwlModalCard>
</template>

<script>

export default {
  name: 'setup-has-balance',
  components: {
    AwlModalCard: () => import('../../../components/Layout/Card/AwlModalCard'),
  },
  methods: {
    goBack () {
      this.$emit('goBack');
    },
  },
};

</script>
